import { useState } from "react";
import { InlineSpinner } from "../components/InlineSpinner";
import { ErrorPage, InlineError, LoadingPage, StudioShell, mvStudioStep } from "../components/StudioShell";
import { ApiError, apiRequest, useWork } from "../lib/api";
import { navigate } from "../lib/navigation";
import { pathForStep } from "../lib/session";

export function MvDonePage({ workId }: { workId: string }) {
  const query = useWork(workId);
  const [moving, setMoving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (query.loading) return <LoadingPage label="완성한 컷을 확인하는 중..." />;
  if (!query.data || query.error) {
    return <ErrorPage message={query.error?.message ?? "완성한 컷을 불러오지 못했습니다."} />;
  }
  return (
    <StudioShell currentStep={mvStudioStep.mv_done} imageRegenRemaining={query.data.image_regen_remaining}>
      <div className="mv-done-page">
        <div className="success-icon" aria-hidden="true">✓</div>
        <h1 tabIndex={-1}>뮤직비디오 컷을 완성했어요</h1>
        <p>{query.data.cuts.length}개 장면이 모두 준비됐어요.</p>
        <div className="mv-done-strip">
          {query.data.cuts.map((cut) => <span key={cut.id}>컷 {cut.idx} ✓</span>)}
        </div>
        <div className="mv-next-stage-note">컷 순서와 움직임을 골라 한 편의 영상으로 완성해요.</div>
        {error ? <InlineError>{error}</InlineError> : null}
        <div className="mv-done-actions">
        {/* 컷을 다시 보러 — 예전엔 편집실에 들어가 「이전」을 눌러야만 돌아갔다(2026-10-07 jery). */}
        <button
          className="button-secondary"
          type="button"
          disabled={moving}
          onClick={() => {
            setMoving(true);
            setError(null);
            void apiRequest(`/api/works/${encodeURIComponent(workId)}/autosave`, {
              method: "POST",
              body: JSON.stringify({ step: "cuts", gifts_v: 2 }),
            }).then(() => navigate(pathForStep(workId, "cuts"))).catch((caught: unknown) => {
              setError(caught instanceof ApiError ? caught.message : "이전 단계로 돌아가지 못했어요.");
              setMoving(false);
            });
          }}
        >
          이전
        </button>
        <button
          className="button-primary mv-done-edit-button"
          type="button"
          disabled={moving}
          onClick={() => {
            setMoving(true);
            setError(null);
            void apiRequest(`/api/works/${encodeURIComponent(workId)}/autosave`, {
              method: "POST",
              body: JSON.stringify({ step: "edit", gifts_v: 2 }),
            }).then(() => navigate(pathForStep(workId, "edit"))).catch((caught: unknown) => {
              setError(caught instanceof ApiError ? caught.message : "편집실을 열지 못했어요.");
              setMoving(false);
            });
          }}
        >
          {moving ? <InlineSpinner label="편집실 여는 중..." /> : "편집실 가기"}
        </button>
        </div>
      </div>
    </StudioShell>
  );
}
